import styled from '@emotion/styled'

export const ReservationSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin-bottom: 20px;
  background: #202327;
  color: white;
  container-name: birthday-grid;
  container-type: inline-size;

  h2 {
    margin: 0 0 5px;
  }
`

export const GuestFields = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 20px 0 30px;

  > div {
    width: 240px;
  }

  @media screen and (max-width: 990px) {
    > div {
      width: 100%;
    }
  }
`

export const QuestLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;

  strong,
  small {
    display: block;
  }

  strong {
    color: white;
    font-size: 12px;
    line-height: 1.25;
  }

  small {
    margin-top: 5px;
    color: #b7c1d3;
    font-size: 11px;
  }
`

export const QuestThumbnail = styled.img`
  width: 58px;
  height: 68px;
  flex: 0 0 auto;
  border-radius: 6px;
  object-fit: cover;

  @media screen and (max-width: 720px) {
    width: 68px;
    height: 78px;
  }

  @media screen and (max-width: 900px) and (hover: none) and (pointer: coarse),
    (horizontal-viewport-segments: 2) {
    width: 68px;
    height: 78px;
  }

  @container birthday-grid (max-width: 720px) {
    width: 68px;
    height: 78px;
  }
`

export const PublicTimeSlot = styled.button<{
  selected?: boolean
  unavailable?: boolean
  reservedSelection?: boolean
}>`
  display: flex;
  width: auto;
  min-width: 64px;
  min-height: 66px;
  padding: 8px 4px;
  margin: 3px;
  border: 2px solid
    ${({ selected, reservedSelection }) =>
      reservedSelection ? '#ffb24d' : selected ? '#fff' : 'transparent'};
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1 1 0;
  color: ${({ unavailable, reservedSelection }) =>
    reservedSelection ? '#fff' : unavailable ? '#717782' : '#fff'};
  background: ${({ selected, unavailable, reservedSelection }) => {
    if (reservedSelection) {
      return 'linear-gradient(135deg, #7a4b0c 0%, #a86712 100%)'
    }
    if (unavailable) return '#24262a'
    if (selected) return '#ff8e00'
    return '#533bff'
  }};
  cursor: ${({ unavailable }) => (unavailable ? 'not-allowed' : 'pointer')};
  opacity: ${({ unavailable, reservedSelection }) =>
    unavailable && !reservedSelection ? 0.7 : 1};
  box-shadow: ${({ reservedSelection }) =>
    reservedSelection
      ? '0 0 0 2px rgba(255, 178, 77, 0.16), inset 0 0 18px rgba(255, 193, 105, 0.1)'
      : 'none'};
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease,
    transform 150ms ease;

  strong {
    font-size: 17px;
  }

  small {
    margin-top: 4px;
    font-size: 11px;
  }

  .reserved-lock {
    margin-bottom: 3px;
    color: #ffd08d;
    font-size: 12px;
  }

  &:hover:not(:disabled),
  &:focus-visible {
    border-color: white;
    outline: none;
    box-shadow: 0 8px 18px rgba(83, 59, 255, 0.34);
    transform: translateY(-1px);
  }

  @container birthday-grid (max-width: 720px) {
    width: calc(33.333% - 6px);
    min-width: 0;
    flex: 0 0 calc(33.333% - 6px);
  }
`

export const TimeSlotLegend = styled.div`
  display: flex;
  margin: 18px 0 -18px;
  flex-wrap: wrap;
  gap: 14px;
  color: #b7c1d3;
  font-size: 12px;

  span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 3px;
    background: #533bff;
  }

  span:nth-of-type(2) i {
    border: 2px solid #fff;
    background: #ff8e00;
  }

  span:nth-of-type(3) i {
    background: #35383e;
    opacity: 0.7;
  }
`

export const ReservedSelectionNotice = styled.div`
  padding: 11px 13px;
  margin: 0 0 14px;
  border: 1px solid #b87318;
  border-radius: 8px;
  color: #ffd08d;
  background: rgba(168, 103, 18, 0.16);
  font-size: 13px;
  line-height: 1.45;

  strong {
    color: #ffb24d;
  }
`

export const AllocationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
`

export const AllocationTitle = styled.div`
  margin-bottom: 4px;

  strong,
  span {
    display: block;
  }

  span {
    color: #b7c1d3;
    font-size: 13px;
  }
`

export const AllocationRow = styled.div`
  display: grid;
  grid-template-columns: minmax(160px, 1fr) minmax(220px, 1.5fr) 220px;
  gap: 10px;
  align-items: center;
  padding: 10px;
  background: #353c4b;

  @media screen and (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

export const PlayerCountOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const PlayerCountButton = styled.button<{ selected?: boolean }>`
  width: 44px;
  height: 44px;
  border: 2px solid ${({ selected }) => (selected ? '#fff' : 'transparent')};
  border-radius: 6px;
  color: white;
  background: ${({ selected }) => (selected ? '#ff8e00' : '#533bff')};
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;

  &:hover,
  &:focus-visible {
    border-color: white;
    outline: none;
  }
`

export const MissingPlayerSelection = styled.span`
  display: block;
  margin-top: 5px;
  color: #ff8e8e;
  font-size: 12px;
`

export const ValidationMessage = styled.div`
  display: flex;
  padding: 10px;
  margin-top: 12px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: white;
  background: #b00020;

  @media screen and (max-width: 720px) {
    align-items: flex-start;
    flex-direction: column;
  }
`

export const AdjustChildrenButton = styled.button`
  min-height: 38px;
  padding: 7px 12px;
  border: 2px solid #fff;
  border-radius: 6px;
  color: #202327;
  background: #fff;
  cursor: pointer;
  flex: 0 0 auto;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;

  &:hover,
  &:focus-visible {
    border-color: #ff8e00;
    outline: none;
    background: #ff8e00;
  }
`

export const LoadingMessage = styled.div`
  padding: 10px;
  margin-bottom: 12px;
  color: white;
  background: #353c4b;
`
